import React from "react";
import { useTranslation } from "react-i18next";
import { GiftTemplate } from "../../../types/modules/admin/giftTemplate.type";
import GiftTemplateItem from "./GiftTemplateItem";
import { PermissionGate } from "../PermissionGate";
import { PermissionsKey } from "../../../data/permissions";

interface Props {
  templates: GiftTemplate[];
}

const GiftTemplateListTable: React.FC<Props> = ({ templates }) => {
  const { t } = useTranslation();

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-separate border-spacing-y-5">
        <thead>
          <tr className="text-start text-sm text-DarkGrey2 font-semibold">
            <th className="p-3 font-normal capitalize">{t("id")}</th>
            <th className="p-3 font-normal capitalize">{t("image")}</th>
            <th className="p-3 font-normal capitalize">{t("startDate")}</th>
            <th className="p-3 font-normal capitalize">{t("endDate")}</th>
            <PermissionGate permissions={[PermissionsKey.UpdateGiftCategory]}>
              <th className="p-3 font-normal capitalize">{t("actions")}</th>
            </PermissionGate>
          </tr>
        </thead>
        <tbody className="text-sm">
          {templates.map((template, index) => (
            <tr
              key={template.id}
              className="bg-white rounded-[12px]"
              style={{ boxShadow: "0px 4px 32px rgba(86, 92, 120, 0.08)" }}
            >
                <GiftTemplateItem template={template}/>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
export default GiftTemplateListTable;